import { useMutation } from '@tanstack/react-query';

import { apiClient } from './client';

export type FeedbackType = 'bug' | 'feature request' | 'improvement';

export interface SubmitFeedbackPayload {
  title: string;
  description: string;
  feedbackTypes: FeedbackType[];
  metadata: {
    route: string;
    userAgent: string;
    appVersion: string;
  };
}

export interface FeedbackOut {
  html_url: string;
}

export function useSubmitFeedback() {
  return useMutation({
    mutationFn: async (payload: SubmitFeedbackPayload) => {
      const { data } = await apiClient.post<FeedbackOut>('/api/community/feedback/', {
        title: payload.title,
        description: payload.description,
        feedback_types: payload.feedbackTypes,
        metadata: {
          route: payload.metadata.route,
          user_agent: payload.metadata.userAgent,
          app_version: payload.metadata.appVersion,
        },
      });
      return data;
    },
  });
}
